<div
  class="modal-header rs-enhanced-header mt-0"
  [class.rs-header--video-review]="show_video"
>
  <div class="rs-header-top">
    <div class="rs-header-content" *ngIf="!show_video">
      <h5 class="modal-title">
        {{
          !showemailSection && !sendInternalmail ? "Request a Story" : "Send Mail"
        }}
      </h5>
      <p
        class="rs-header-description"
        *ngIf="!showemailSection && !sendInternalmail"
      >
        Invite someone to share a story, or craft a prompt your community can
        answer.
      </p>
    </div>
    <!-- Hidden while reviewing the greeting video: it closed the whole
         Request a Story modal. Accept / New / Remove leave that view. -->
    <button
      *ngIf="!show_video"
      type="button"
      (click)="cancel()"
      class="close"
      [style.color]="isShowModal ? panelCloseColor : null"
    >
      <span aria-hidden="true">
        <svg role="img">
          <use xlink:href="#icon-close"></use></svg
      ></span>
    </button>
  </div>
  <div
    *ngIf="!showemailSection && !sendInternalmail && !show_video && !isDispalyMenu && showRequestAudienceToggle()"
    class="user-type-tabs-container"
    [ngClass]="{ diable_pointer: disableSubmit }"
  >
    <div class="user-type-pill-toggle">
      <button
        type="button"
        class="user-type-pill-option"
        [class.active]="requestForm.value.userStatus === 'user'"
        (click)="setUserStatus('user')"
      >
        From a User
      </button>
      <button
        type="button"
        class="user-type-pill-option"
        [class.active]="requestForm.value.userStatus === 'Guestuser'"
        (click)="setUserStatus('Guestuser')"
      >
        From a Guest
      </button>
    </div>
  </div>
</div>
<div class="tag_conatainer">
  <div
    class="modal-body request-story"
    [ngClass]="{
      expand: isShowModal,
      'has-expanded-links':
        showAllRequestLinks && filteredRequestLinks.length > 3
    }"
    [formGroup]="requestForm"
  >
    <div
      class="rs-creating-overlay"
      *ngIf="isLoading && !isCopyCode && !hideSendanCopylinkButton"
    >
      <div class="rs-creating-overlay__card" role="status" aria-live="polite">
        <div class="lds-ellipsis rs-creating-overlay__spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <p class="rs-creating-overlay__title">Creating request links</p>
        <p class="rs-creating-overlay__subtitle">
          Please wait a moment…
        </p>
      </div>
    </div>
    <div class="rs-panel-stack">
    <div class="rs-user-panel" *ngIf="requestForm.value.userStatus == 'user'">
      <div class="rs-modal-scroll" [class.is-prompts-open]="isDispalyMenu">
      <!-- Legacy copy list replaced by Request links table -->
      <div
        *ngIf="false"
        (keyup.enter)="handleComKeyEnter()"
        class="story-flow-view__box view-box-people outline-none"
        [ngClass]="{ current: !viewmodel.isStoryCreating }"
      >
        <form
          [hidden]="isCopyCode"
          [formGroup]="form"
          class="view-box-people__search setting_form"
          (keyup.enter)="exceptHandleComKeyEnter($event)"
        >
          <div class="view-box-media__tab-item">
            <div class="search-input">
              <input
                id="searchUnsplash"
                formControlName="keyword"
                type="text"
                placeholder="Search"
                class="form-control"
                autofocus
              />
            </div>
            <div
              class="view-box-people__search-button button-label"
              [ngClass]="{ searching: viewmodel.searching }"
            >
              <div [hidden]="!viewmodel.searching" class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <button [hidden]="viewmodel.searching" type="submit">
                <i class=""></i>
              </button>
            </div>
          </div>
        </form>
        <div class="view-box-people__result spacer">
          <div class="no___members" *ngIf="members && members?.length == 0">
            NO USER FOUND.
            <span *ngIf="initialState.public"
              >Invite them to submit as a guest.</span
            >
          </div>
          <scrollbar
            #scrollbar
            *ngIf="members && members?.length > 0"
            (onYReachEnd)="onYReachEnd()"
            (onPositionChanged)="onPositionChanged()"
          >
            <div class="l-people-result">
              <label
                class="l-people-result__item"
                *ngFor="
                  let player of members;
                  index as i;
                  trackBy: memberTrackByFnc
                "
                title="{{ player.title ? player.title : '' }}"
              >
                <span class="l_people_request">
                  <gs-avatar
                    [src]="player.avatar"
                    isBackground="true"
                    classCss="avatar"
                  ></gs-avatar>
                </span>

                <ng-container *ngIf="player.storyInviteEnabled !== false">
                  <span class="l-people-result__content">
                    <span class="l-people-result__name"
                      >{{ player.display_name }}&nbsp;-</span
                    >
                    <span class="l-people-result__mail"
                      >&nbsp;{{ player.email }}</span
                    >
                  </span>
                  <span class="l-people-result__checkbox" *ngIf="!isCopyCode">
                    <input
                      type="checkbox"
                      [(ngModel)]="player.checked"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="selectItem(player)"
                    />
                    <span> </span>
                  </span>
                  <span class="l-people-result__checkbox" *ngIf="isCopyCode">
                    <span
                      data-toggle="tooltip"
                      #copyToolTip
                      class="copy-text-{{ i }}"
                      data-placement="right"
                      [title]="
                        !hideSendanCopylinkButton
                          ? 'Create new link first'
                          : 'Click to copy'
                      "
                      [style.opacity]="!hideSendanCopylinkButton ? '0.5' : '1'"
                      [style.cursor]="
                        !hideSendanCopylinkButton ? 'not-allowed' : 'pointer'
                      "
                      ><span></span>
                      <span
                        (click)="
                          !hideSendanCopylinkButton
                            ? $event.stopPropagation()
                            : copyMessage(player, copyToolTip)
                        "
                        ><i class="fas fa-link"></i
                      ></span>
                      <span> </span>
                    </span>
                  </span>
                </ng-container>

                <ng-container
                  *ngIf="player.storyInviteEnabled === false && !player.checked"
                >
                  <span class="l-people-result__content">
                    <span class="l-people-result__name text-dark">
                      <span
                        data-toggle="tooltip"
                        data-placement="right"
                        title="Unavailable to add"
                        class="pr-2"
                        ><span>{{ player.display_name }} &nbsp;</span>
                        <svg role="img" class="icon16">
                          <use xlink:href="#icon-info"></use>
                        </svg>
                      </span>
                    </span>
                    <span class="l-people-result__mail"
                      >-&nbsp;{{ player.email }}</span
                    >
                  </span>
                </ng-container>
                <span class="copied-success mt-1" *ngIf="player?.linkCopied"
                  >Link copied!</span
                >
              </label>
              <div
                class="l-story-box-media__loading"
                [hidden]="!loadMore || viewmodel.searching"
                *ngIf="!isCopyCode"
              >
                Loading more ....
              </div>
            </div>
          </scrollbar>
          <div
            class="container mt-5 text-center"
            *ngIf="
              viewmodel.isPlayerCreating ||
              (viewmodel.isPlayerLoading && !(members && members?.length > 0))
            "
          >
            <div class="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
      <!-- Compact People Selection Dropdown -->
      <div class="people-selection-container" *ngIf="!isCopyCode">
        <div class="people-dropdown-wrapper">
          <div class="simple-dropdown-wrapper">
            <div
              class="simple-dropdown-label"
              [style.display]="
                isDropdownFocused ||
                (selectedPeopleIds && selectedPeopleIds.length > 0) ||
                isDropdownTyping
                  ? 'none'
                  : 'block'
              "
            >
              Search Names
            </div>
            <ng-select
              class="people-select"
              [items]="members"
              [multiple]="true"
              [closeOnSelect]="false"
              [clearable]="true"
              [searchable]="true"
              [loading]="viewmodel.searching"
              bindLabel="email"
              bindValue="id"
              placeholder=""
              [hideSelected]="false"
              [(ngModel)]="selectedPeopleIds"
              (change)="onPeopleSelectionChange($event)"
              [ngModelOptions]="{ standalone: true }"
              (search)="onPeopleSearch($event)"
              (focus)="onDropdownFocus()"
              (blur)="onDropdownBlur()"
              (searchChange)="onDropdownSearchChange($event)"
            >
              <!-- Custom option template with avatar and email -->
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <div class="people-option">
                  <gs-avatar
                    [src]="item.avatar"
                    isBackground="true"
                    classCss="option-avatar"
                  ></gs-avatar>
                  <div class="people-info">
                    <span class="people-name">{{ item.display_name }}</span>
                    <span class="people-email">{{ item.email }}</span>
                  </div>
                </div>
              </ng-template>

              <ng-template
                ng-multi-label-tmp
                let-items="items"
                let-clear="clear"
              >
                <div class="selected-people-container">
                  <span
                    class="selected-name-chip"
                    *ngFor="let item of items"
                    [attr.title]="item.email"
                  >
                    <span class="selected-name-chip__label">{{
                      item.display_name || item.displayName || item.email
                    }}</span>
                    <!-- mousedown is swallowed so removing a chip doesn't open the dropdown -->
                    <button
                      type="button"
                      class="selected-name-chip__remove"
                      [attr.aria-label]="'Remove ' + (item.display_name || item.displayName || item.email)"
                      (mousedown)="$event.stopPropagation(); $event.preventDefault()"
                      (click)="$event.stopPropagation(); clear(item)"
                    >
                      &times;
                    </button>
                  </span>
                  <span class="selected-count" *ngIf="items?.length"
                    >{{ items.length }} selected</span
                  >
                </div>
              </ng-template>
            </ng-select>
          </div>

          <div
            class="search-results-counter"
            *ngIf="searchResultsCount !== null"
          >
            {{ searchResultsCount }} results
          </div>
        </div>
      </div>

      <div
        class="rs-request-links"
        *ngIf="isCopyCode && selectedRequestLinks.length > 0"
      >
        <div class="rs-request-links__header">
          <h6 class="rs-request-links__title">
            Request links
            <span class="rs-request-links__badge">{{
              selectedRequestLinks.length
            }}</span>
          </h6>
          <input
            *ngIf="selectedRequestLinks.length > 3"
            type="text"
            class="rs-request-links__search"
            placeholder="Search"
            [(ngModel)]="requestLinksQuery"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>

        <ul
          class="rs-request-links__list"
          [class.is-expanded]="
            showAllRequestLinks && filteredRequestLinks.length > 3
          "
        >
          <li
            class="rs-request-links__row"
            *ngFor="let person of visibleRequestLinks; trackBy: memberTrackByFnc"
          >
            <div class="rs-request-links__meta">
              <span class="rs-request-links__name">{{
                person.display_name || person.displayName
              }}</span>
              <span class="rs-request-links__email">{{ person.email }}</span>
            </div>
            <div class="rs-request-links__actions">
              <button
                type="button"
                class="rs-copy-link-btn"
                [disabled]="!person.url"
                [attr.title]="
                  person.url ? 'Click to copy' : 'Create link first'
                "
                (click)="copyRequestLink(person, $event)"
              >
                {{ person.linkCopied ? "Copied" : "Copy Link" }}
              </button>
              <button
                type="button"
                class="rs-remove-link-btn"
                aria-label="Remove"
                title="Remove"
                (click)="removeRequestLink(person)"
              >
                &times;
              </button>
            </div>
          </li>
        </ul>

        <button
          type="button"
          class="rs-show-all-links"
          *ngIf="filteredRequestLinks.length > 3"
          (click)="toggleShowAllRequestLinks()"
        >
          {{
            showAllRequestLinks
              ? "Show less"
              : "Show all " + filteredRequestLinks.length
          }}
        </button>
      </div>

      <div class="email-popup-box" *ngIf="sendInternalmail">
        <div class="email-popup-header">
          <!--  <h6 class="mb-0 font-weight-bold">Edit Email Subject & Message</h6> -->
        </div>

        <div class="form-group mt-3" *ngIf="!is_not_other_email">
          <gs-input-material
            label="Sender Name"
            name="Sender Name"
            formControlName="emailSendername"
            placeholder="E.g., We'd love to hear your story!"
            [formControl]="requestForm.controls.emailSendername"
            type="text"
          ></gs-input-material>
        </div>
        <!-- Subject Input -->
        <div class="form-group mt-3">
          <gs-input-material
            label="Email Subject"
            name="emailSubject"
            formControlName="emailSubject"
            placeholder="E.g., We'd love to hear your story!"
            [formControl]="requestForm.controls.emailSubject"
            type="text"
          ></gs-input-material>
        </div>

        <!-- Email Body WYSIWYG -->
        <div class="form-group">
          <gs-area-wysiwyg
            label="Email Message"
            name="emailTemplate"
            placeholder="Type your message here..."
            rows="6"
            formControlName="emailTemplate"
            [formControl]="requestForm.controls.emailTemplate"
            type="text"
          ></gs-area-wysiwyg>
        </div>
      </div>
      <div *ngIf="!sendInternalmail">
        <!--<div class="mb-3"><h6 class="font-weight-bold mr-3 mt-3">Pick a Prompt</h6></div>-->
        <ng-container>
          <div class="prompt-tabs-container" *ngIf="lockChosenPrompt">
            <div class="single-dropdown-container">
              <div class="form-label-group force-focus prompt-locked" [title]="lockedPromptLabel">
                <select class="form-control" disabled aria-label="Single Prompts">
                  <option>{{ lockedPromptLabel }}</option>
                </select>
                <label>Single Prompts</label>
              </div>
            </div>
          </div>
          <!-- Tabbed Interface -->
          <div class="prompt-tabs-container" *ngIf="!lockChosenPrompt">
            <div class="prompt-tabs-header">
              <div class="prompt-tabs">
                <button
                  type="button"
                  class="tab-button"
                  [class.active]="activePromptTab === 'campaign'"
                  [style.border-bottom-color]="
                    activePromptTab === 'campaign' && secondary_button_color
                      ? secondary_button_color
                      : ''
                  "
                  (click)="setActivePromptTab('campaign')"
                >
                  Campaign Prompts
                </button>
                <button
                  type="button"
                  class="tab-button"
                  [class.active]="activePromptTab === 'single'"
                  [style.border-bottom-color]="
                    activePromptTab === 'single' && secondary_button_color
                      ? secondary_button_color
                      : ''
                  "
                  (click)="setActivePromptTab('single')"
                >
                  Single Prompts
                </button>
              </div>

              <span
                [hidden]="activePromptTab !== 'single'"
                class="addquestion-tab"
                (click)="addquestion()"
              >
                <i class="fa-regular fa-plus"></i> New Prompt
              </span>
              <span
                [hidden]="
                  activePromptTab !== 'campaign' ||
                  requestForm.value.campaign == -1
                "
                class="addquestion-tab"
                (click)="isDispalyMenu = true; show_video = false"
              >
                View Prompts
              </span>
            </div>

            <div class="single-dropdown-container">
              <div class="row">
                <div class="col-12">
                  <!-- Single Prompts -->
                  <!-- ng-select instead of a native <select>: macOS draws native
                       menus on top of the field; this always opens below it. -->
                  <ng-select
                    *ngIf="activePromptTab === 'single'"
                    class="prompt-select"
                    placeholder="Select option"
                    aria-label="Single Prompts"
                    formControlName="question"
                    [items]="promptOptions(userQuestion)"
                    bindValue="id"
                    bindLabel="question_text"
                    dropdownPosition="bottom"
                    [clearable]="false"
                    [searchable]="false"
                    (change)="onPromptSelect($event)"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      <span [class.prompt-select-empty]="!item?.id || item.id == -1">{{
                        item?.id && item.id != -1 ? (item.title || item.question_text) : "Select option"
                      }}</span>
                    </ng-template>
                  </ng-select>

                  <!-- Campaign Prompts -->
                  <ng-select
                    *ngIf="activePromptTab !== 'single'"
                    class="prompt-select"
                    placeholder="Select option"
                    aria-label="Campaign Prompts"
                    formControlName="campaign"
                    [items]="promptOptions(getActivePromptData())"
                    bindValue="id"
                    bindLabel="title"
                    dropdownPosition="bottom"
                    [clearable]="false"
                    [searchable]="false"
                    (change)="onPromptSelect($event)"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      <span [class.prompt-select-empty]="!item?.id || item.id == -1">{{
                        item?.id && item.id != -1 ? (item.title || item.question_text) : "Select option"
                      }}</span>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </div>
          </div>

          <div class="rs-action-cards-section">
            <!--<h6 class="font-weight-bold mb-3 mr-3 mt-3">Help Them Get Started</h6>-->
            <div class="action-cards-row">
              <button
                type="button"
                class="action-card"
                [class.is-open]="isGreetingOpen"
                (click)="!is_video ? startRecording() : watchVideo()"
              >
                <span class="action-card-icon">
                  <i class="fa-solid fa-video" aria-hidden="true"></i>
                </span>
                <span class="action-card-label">{{
                  !is_video ? "Add Greeting" : "Watch Video"
                }}</span>
                <span
                  *ngIf="greetingSelectedCount > 0"
                  class="action-card-count"
                  >{{ greetingSelectedCount }}</span
                >
              </button>
              <button
                type="button"
                class="action-card"
                [class.is-open]="isTagsOpen"
                [disabled]="
                  stepActive && stepActive.length && stepActive.length == 1
                "
                (click)="addTag()"
              >
                <span class="action-card-icon">
                  <i class="fa-solid fa-tags" aria-hidden="true"></i>
                </span>
                <span class="action-card-label">{{
                  hasTagsSelected ? "Tags Added" : "Add Tags"
                }}</span>
                <span
                  *ngIf="tagsSelectedCount > 0"
                  class="action-card-count"
                  >{{ tagsSelectedCount }}</span
                >
              </button>
              <button
                type="button"
                class="action-card"
                [class.is-open]="isMediaOpen"
                (click)="addMedia()"
              >
                <span class="action-card-icon">
                  <i class="fa-solid fa-image" aria-hidden="true"></i>
                </span>
                <span class="action-card-label">{{
                  hasMediaSelected ? "Media Added" : "Add Media"
                }}</span>
                <span
                  *ngIf="mediaSelectedCount > 0"
                  class="action-card-count"
                  >{{ mediaSelectedCount }}</span
                >
              </button>
            </div>
            <div
              class="rs-greeting-upload-progress rs-greeting-upload-progress--ready"
              *ngIf="greetingReady && !uploaderViewModel.isUploading && !showelipse"
              role="status"
            >
              <p class="rs-greeting-upload-progress__label">
                Greeting video added. You can create the link.
              </p>
            </div>
            <div
              class="rs-greeting-upload-progress"
              *ngIf="uploaderViewModel.isUploading || showelipse"
            >
              <p class="rs-greeting-upload-progress__label">
                {{
                  uploaderViewModel.isUploading
                    ? "Uploading video… " + uploaderViewModel.progress + "%"
                    : uploaderViewModel.progress >= 100
                      ? "Video uploaded"
                      : "Processing video…"
                }}
              </p>
              <div class="rs-greeting-upload-progress__track">
                <div
                  class="rs-greeting-upload-progress__fill"
                  [style.width]="
                    uploaderViewModel.isUploading
                      ? uploaderViewModel.progressCss
                      : '100%'
                  "
                ></div>
              </div>
            </div>
          </div>

          <!--<div class="openCampaignprompts" *ngIf="requestForm.value.campaign != -1"  (click)="isDispalyMenu = true ">View Campaign Prompts</div>-->
          <div
            class="remark-box"
            [class.is-open]="isDispalyMenu"
            [attr.aria-hidden]="!isDispalyMenu"
            [@showhide]="isDispalyMenu ? 'show' : 'hide'"
            (click)="$event.stopPropagation()"
          >
            <div class="remark-box__header">
              <h6 class="remark-box__title">
                {{ show_video ? "Greeting Video" : "Campaign Prompts" }}
              </h6>
            </div>
            <div class="remark-conatiner" *ngIf="!show_video">
              <label *ngFor="let question of camapignqueston; index as i"
                >{{ i + 1 }} - {{ question }}</label
              >
            </div>

            <div class="video_container" *ngIf="show_video && isDispalyMenu">
              <video
                class="video_player"
                #videoPlayer
                controls
                width="100%"
              ></video>

              <div class="video-actions-buttons">
                <button class="btn btn-accept" (click)="acceptVideo()">
                  <i class="fas fa-check"></i>&nbsp; Accept
                </button>
                <button class="btn btn-new" (click)="rerecordVideo()">
                  <i class="fas fa-video"></i>&nbsp; New
                </button>
                <button class="btn btn-remove" (click)="removeVideo()">
                  <i class="fas fa-trash"></i>&nbsp; Remove
                </button>
              </div>
            </div>

            <!-- Back button to return to main modal -->
            <div class="text-center mt-4 mb-2" *ngIf="!show_video">
              <button
                type="button"
                class="btn btn-secondary"
                (click)="isDispalyMenu = false"
              >
                <i class="fas fa-arrow-left"></i>&nbsp; Back to Request
              </button>
            </div>
          </div>
        </ng-container>
        <ng-container
          *ngIf="
            showRequestedUser &&
            requestedMembers.length > 1 &&
            !sendInternalmail
          "
        >
          <div class="author_container">
            <div class="author-label-toggle">
              <div class="author-toggle-text">
                <h6 class="font-weight-bold mb-0">Change Requestor</h6>
                <p class="author-toggle-subtext">
                  Send this request on behalf of someone else
                </p>
              </div>
              <label class="switch">
                <input
                  type="checkbox"
                  [(ngModel)]="showAuthorDropdown"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="onAuthorToggleChange($event)"
                />
                <span
                  class="slider"
                  [style.background-color]="
                    showAuthorDropdown && secondary_button_color
                      ? secondary_button_color
                      : ''
                  "
                ></span>
              </label>
            </div>
            <div class="job__select" *ngIf="showAuthorDropdown">
              <ng-select
                class="job-select"
                [items]="requestedMembers"
                [multiple]="false"
                [closeOnSelect]="true"
                [selectableGroup]="true"
                maxSelectedItems="1"
                bindValue="id"
                bindLabel="title"
                formControlName="userselcted"
              >
                <ng-template
                  ng-option-tmp
                  let-item="item"
                  let-item$="item$"
                  let-index="index"
                >
                  <div class="mobile-check custom-control custom-checkbox">
                    <input
                      id="item-{{ index }}"
                      class="custom-control-input"
                      type="checkbox"
                      [ngModelOptions]="{ standalone: true }"
                      [ngModel]="item$.selected"
                    />
                    <label class="custom-control-label">{{ item.title }}</label>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </ng-container>
        <div
          class="row froala-wysiwyg"
          *ngIf="!sendInternalmail"
          [formGroup]="requestForm"
        >
          <div class="col-12 request_edit">
            <gs-area-wysiwyg
              label="Content"
              name="Message"
              placeholder="Add a popup greeting, instructions, or a story tip..."
              rows="7"
              cssClass="spacing-lg"
              is
              name="Content"
              formControlName="internalmessage"
              [formControl]="requestForm.controls.internalmessage"
              type="text"
              [autoFocus]="true"
            ></gs-area-wysiwyg>
          </div>
        </div>
      </div>

      <!-- <h6 *ngIf="!isCopyCode">Select Language</h6>     

        <div class="people-selection-container" *ngIf="!isCopyCode">
          <div class="people-dropdown-wrapper">
            <div class="simple-dropdown-wrapper">
              <div class="simple-dropdown-label" 
                   [style.display]="(requestForm.value.languageSelected || isDropdownFocused || isDropdownTyping) ? 'none' : 'block'">
                Search Language
              </div>
              <ng-select
              class="job-select"
              [items]="selectedLanguages"
              [multiple]="false"
              [closeOnSelect]="true"
              [selectableGroup]="true"
              maxSelectedItems="1"
              bindValue="code"
              bindLabel="name"
              formControlName="languageSelected"
            >
              <ng-template
                ng-option-tmp
                let-item="item"
                let-item$="item$"
                let-index="index"
              >
                <div class="mobile-check custom-control custom-checkbox d-flex align-items-center">
                  <input
                    id="lang-{{ index }}"
                    class="custom-control-input"
                    type="checkbox"
                    [ngModelOptions]="{ standalone: true }"
                    [ngModel]="item$.selected"
                  />
                  <label class="custom-control-label d-flex align-items-center">
                    <img
                      [src]="item.flag"
                      width="20"
                      height="14"
                      class="me-2"
                    />
                    {{ item.name }}
                  </label>
                </div>
              </ng-template>
            </ng-select>
            </div>
          </div>
        </div> -->
      </div>

      <div class="generate__box">
        <ng-container>
          <div class="mr-3" *ngIf="sendInternalmail">
            <button
              type="button"
              [style.background]="primary_color ? secondary_button_color : ''"
              (click)="backInternalStories()"
              class="btn btn-pink min-width rs-footer-btn rs-footer-btn--secondary"
            >
              Back
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="!sendInternalmail">
          <div
            class="ml-0"
            (click)="
              !hideSendanCopylinkButton
                ? GenearateInternalMainlLink()
                : openMailBox()
            "
          >
            <div class="dot-pulse" *ngIf="showelipse || isLoading"></div>
            <button
              type="button"
              [style.background]="primary_color ? secondary_button_color : ''"
              [disabled]="
                !selectedData.length ||
                isLoading ||
                (requestForm.value.campaign == -1 &&
                  requestForm.value.question == -1) ||
                diableonsearching ||
                isGreetingVideoPending ||
                disableSubmit
              "
              class="btn btn-pink min-width rs-footer-btn rs-footer-btn--primary"
            >
              {{
                isLoading && !hideSendanCopylinkButton
                  ? "Creating…"
                  : !hideSendanCopylinkButton
                  ? "Create Link"
                  : "Send Email"
              }}
            </button>
          </div>
        </ng-container>
        <ng-container>
          <div class="mr-3" *ngIf="sendInternalmail">
            <button
              type="button"
              [style.background]="primary_color ? secondary_button_color : ''"
              (click)="sendIntenalMainEmail()"
              class="btn btn-pink min-width rs-footer-btn rs-footer-btn--primary"
            >
              Send
            </button>
          </div>
        </ng-container>
        <ng-container>
          <div class="lang-icon-select" *ngIf="!sendInternalmail">
            <button
              type="button"
              class="rs-footer-btn rs-footer-btn--secondary"
              (click)="toggleLangDropdown($event)"
            >
              <i class="far fa-language"></i>
              <span>Translate</span>
            </button>

            <!-- CUSTOM DROPDOWN -->
            <ul class="icon-dropdown" *ngIf="langDropdownOpen">
              <li
                *ngFor="let lang of selectedLanguages"
                (click)="selectLanguage(lang, $event)"
                [class.active]="
                  lang.code === requestForm.get('languageSelected')?.value
                "
              >
                <img [src]="lang.flag" width="20" height="14" />
                {{ lang.name }}
              </li>
            </ul>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="rs-user-panel" *ngIf="requestForm.value.userStatus == 'Guestuser'">
      <div class="rs-modal-scroll" [class.is-prompts-open]="isDispalyMenu">
      <!--<h6 class="mr-3">Author Details</h6>-->
      <div class="">
        <div class="row rs-guest-name mt-1 mb-3" *ngIf="!showemailSection">
          <div class="col-12">
            <gs-input-material
              #guestNameInput
              label="Guest Name or Note*"
              name="Description*"
              placeholder="Guest Name or Note*"
              formControlName="note_email"
              [formControl]="requestForm.controls.note_email"
              type="text"
              [hideErrorMessage]="true"
            ></gs-input-material>
          </div>
        </div>
      </div>

      <div
        class="email-popup-box"
        *ngIf="isSingleInternalRequested && showemailSection"
      >
        <div class="guest_email" formArrayName="users" class="mb-4">
          <div
            *ngFor="let user of users.controls; let i = index"
            [formGroupName]="i"
            class="row mb-2 align-items-center"
          >
            <!-- First Name -->
            <div class="col-md-5">
              <gs-input-material
                label="First Name*"
                name="firstName-{{ i }}"
                placeholder="Enter First Name"
                formControlName="firstName"
                [formControl]="user.get('firstName')"
                type="text"
              >
              </gs-input-material>
            </div>

            <!-- Email -->
            <div class="col-md-5">
              <gs-input-material
                label="Email*"
                name="email-{{ i }}"
                placeholder="Enter Email"
                formControlName="author_email"
                [formControl]="user.get('author_email')"
                type="text"
              >
              </gs-input-material>
            </div>

            <!-- Actions -->
            <div class="col-md-2 d-flex gap-2 align-items-center">
              <!-- Add (only if last is valid) -->
              <ng-container>
                <button
                  type="button"
                  class="btn btn-success btn-icon add_btn"
                  [disabled]="!lastUserValid"
                  (click)="addUser()"
                  title="Add another"
                >
                  <i class="fa fa-plus"></i>
                </button>
              </ng-container>

              <!-- Remove (if more than one user) -->
              <ng-container *ngIf="users.length > 1">
                <button
                  type="button"
                  class="btn btn-danger btn-icon remove_btn"
                  (click)="removeUser(i)"
                  title="Remove user"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </ng-container>
            </div>
          </div>
        </div>

        <div class="email-popup-header">
          <!--  <h6 class="mb-0 font-weight-bold">Edit Email Subject & Message</h6> -->
        </div>

        <div class="form-group mt-3" *ngIf="!is_not_other_email">
          <gs-input-material
            label="Sender Name"
            name="Sender Name"
            formControlName="emailSendername"
            placeholder="E.g., We'd love to hear your story!"
            [formControl]="requestForm.controls.emailSendername"
            type="text"
          ></gs-input-material>
        </div>
        <!-- Subject Input -->
        <div class="form-group mt-3">
          <gs-input-material
            label="Email Subject"
            name="emailSubject"
            formControlName="emailSubject"
            placeholder="E.g., We'd love to hear your story!"
            [formControl]="requestForm.controls.emailSubject"
            type="text"
          ></gs-input-material>
        </div>

        <!-- Email Body WYSIWYG -->
        <div class="form-group">
          <gs-area-wysiwyg
            label="Email Message"
            name="emailTemplate"
            placeholder="Type your message here..."
            rows="6"
            formControlName="emailTemplate"
            [formControl]="requestForm.controls.emailTemplate"
            type="text"
          ></gs-area-wysiwyg>
        </div>
      </div>

      <div *ngIf="!showemailSection">
        <!--<div  *ngIf="!showemailSection" class="mb-3"><h6 class="font-weight-bold mr-3 mt-3">Pick a Prompt</h6></div>-->
        <ng-container>
          <div class="prompt-tabs-container" *ngIf="lockChosenPrompt">
            <div class="single-dropdown-container">
              <div class="form-label-group force-focus prompt-locked" [title]="lockedPromptLabel">
                <select class="form-control" disabled aria-label="Single Prompts">
                  <option>{{ lockedPromptLabel }}</option>
                </select>
                <label>Single Prompts</label>
              </div>
            </div>
          </div>
          <!-- Tabbed Interface for External Users -->
          <div class="prompt-tabs-container" *ngIf="!lockChosenPrompt">
            <div class="prompt-tabs-header">
              <div class="prompt-tabs">
                <button
                  type="button"
                  class="tab-button"
                  [class.active]="activePromptTab === 'campaign'"
                  [style.border-bottom-color]="
                    activePromptTab === 'campaign' && secondary_button_color
                      ? secondary_button_color
                      : ''
                  "
                  (click)="setActivePromptTab('campaign')"
                >
                  Campaign Prompts
                </button>
                <button
                  type="button"
                  class="tab-button"
                  [class.active]="activePromptTab === 'single'"
                  [style.border-bottom-color]="
                    activePromptTab === 'single' && secondary_button_color
                      ? secondary_button_color
                      : ''
                  "
                  (click)="setActivePromptTab('single')"
                >
                  Single Prompts
                </button>
              </div>

              <span
                [hidden]="activePromptTab !== 'single'"
                class="addquestion-tab"
                (click)="addquestion()"
              >
                <i class="fa-regular fa-plus"></i> New Prompt
              </span>
              <span
                [hidden]="
                  activePromptTab !== 'campaign' ||
                  requestForm.value.externalcampaign == -1
                "
                class="addquestion-tab"
                (click)="isDispalyMenu = true; show_video = false"
              >
                View Prompts
              </span>
            </div>

            <div class="single-dropdown-container">
              <div class="row">
                <div class="col-12">
                  <ng-select
                    *ngIf="activePromptTab === 'single'"
                    class="prompt-select"
                    placeholder="Select option"
                    aria-label="Single Prompts"
                    formControlName="externalquestion"
                    [items]="promptOptions(guestquestion)"
                    bindValue="id"
                    bindLabel="question_text"
                    dropdownPosition="bottom"
                    [clearable]="false"
                    [searchable]="false"
                    (change)="onPromptSelect($event)"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      <span [class.prompt-select-empty]="!item?.id || item.id == -1">{{
                        item?.id && item.id != -1 ? (item.title || item.question_text) : "Select option"
                      }}</span>
                    </ng-template>
                  </ng-select>

                  <ng-select
                    *ngIf="activePromptTab !== 'single'"
                    class="prompt-select"
                    placeholder="Select option"
                    aria-label="Campaign Prompts"
                    formControlName="externalcampaign"
                    [items]="promptOptions(getActivePromptData())"
                    bindValue="id"
                    bindLabel="title"
                    dropdownPosition="bottom"
                    [clearable]="false"
                    [searchable]="false"
                    (change)="onPromptSelect($event)"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      <span [class.prompt-select-empty]="!item?.id || item.id == -1">{{
                        item?.id && item.id != -1 ? (item.title || item.question_text) : "Select option"
                      }}</span>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </div>
          </div>

          <div class="rs-action-cards-section">
            <!--<h6 class="font-weight-bold mb-3 mr-3 mt-3">Help Them Get Started</h6>-->
            <div class="action-cards-row">
              <button
                type="button"
                class="action-card"
                [class.is-open]="isGreetingOpen"
                (click)="!is_video ? startRecording() : watchVideo()"
              >
                <span class="action-card-icon">
                  <i class="fa-solid fa-video" aria-hidden="true"></i>
                </span>
                <span class="action-card-label">{{
                  !is_video ? "Add Greeting" : "Watch Video"
                }}</span>
                <span
                  *ngIf="greetingSelectedCount > 0"
                  class="action-card-count"
                  >{{ greetingSelectedCount }}</span
                >
              </button>
              <button
                type="button"
                class="action-card"
                [class.is-open]="isTagsOpen"
                [disabled]="
                  stepActive && stepActive.length && stepActive.length == 1
                "
                (click)="addTag()"
              >
                <span class="action-card-icon">
                  <i class="fa-solid fa-tags" aria-hidden="true"></i>
                </span>
                <span class="action-card-label">{{
                  hasTagsSelected ? "Tags Added" : "Add Tags"
                }}</span>
                <span
                  *ngIf="tagsSelectedCount > 0"
                  class="action-card-count"
                  >{{ tagsSelectedCount }}</span
                >
              </button>
              <button
                type="button"
                class="action-card"
                [class.is-open]="isMediaOpen"
                (click)="addMedia()"
              >
                <span class="action-card-icon">
                  <i class="fa-solid fa-image" aria-hidden="true"></i>
                </span>
                <span class="action-card-label">{{
                  hasMediaSelected ? "Media Added" : "Add Media"
                }}</span>
                <span
                  *ngIf="mediaSelectedCount > 0"
                  class="action-card-count"
                  >{{ mediaSelectedCount }}</span
                >
              </button>
            </div>
            <div
              class="rs-greeting-upload-progress rs-greeting-upload-progress--ready"
              *ngIf="greetingReady && !uploaderViewModel.isUploading && !showelipse"
              role="status"
            >
              <p class="rs-greeting-upload-progress__label">
                Greeting video added. You can create the link.
              </p>
            </div>
            <div
              class="rs-greeting-upload-progress"
              *ngIf="uploaderViewModel.isUploading || showelipse"
            >
              <p class="rs-greeting-upload-progress__label">
                {{
                  uploaderViewModel.isUploading
                    ? "Uploading video… " + uploaderViewModel.progress + "%"
                    : uploaderViewModel.progress >= 100
                      ? "Video uploaded"
                      : "Processing video…"
                }}
              </p>
              <div class="rs-greeting-upload-progress__track">
                <div
                  class="rs-greeting-upload-progress__fill"
                  [style.width]="
                    uploaderViewModel.isUploading
                      ? uploaderViewModel.progressCss
                      : '100%'
                  "
                ></div>
              </div>
            </div>
          </div>

          <!--<div class="openCampaignprompts" *ngIf="requestForm.value.externalcampaign != -1"  (click)="isDispalyMenu = true ">View Campaign Prompts</div>-->

          <div
            class="remark-box"
            [class.is-open]="isDispalyMenu"
            [attr.aria-hidden]="!isDispalyMenu"
            [@showhide]="isDispalyMenu ? 'show' : 'hide'"
            (click)="$event.stopPropagation()"
          >
            <div class="remark-box__header">
              <h6 class="remark-box__title">
                {{ show_video ? "Greeting Video" : "Campaign Prompts" }}
              </h6>
            </div>
            <div class="remark-conatiner" *ngIf="!show_video">
              <div
                class="mb-2"
                *ngFor="let question of externalCampaignQuestion; index as i"
              >
                {{ i + 1 }} - {{ question }}
              </div>
            </div>
            <div class="video_container" *ngIf="show_video && isDispalyMenu">
              <video
                class="video_player"
                #videoPlayer
                controls
                width="100%"
              ></video>

              <div class="video-actions-buttons">
                <button class="btn btn-accept" (click)="acceptVideo()">
                  <i class="fas fa-check"></i>&nbsp; Accept
                </button>
                <button class="btn btn-new" (click)="rerecordVideo()">
                  <i class="fas fa-video"></i>&nbsp; New
                </button>
                <button class="btn btn-remove" (click)="removeVideo()">
                  <i class="fas fa-trash"></i>&nbsp; Remove
                </button>
              </div>
            </div>

            <!-- Back button to return to main modal -->
            <div class="text-center mt-4 mb-2" *ngIf="!show_video">
              <button
                type="button"
                class="btn btn-secondary"
                (click)="isDispalyMenu = false"
              >
                <i class="fas fa-arrow-left"></i>&nbsp; Back to Request
              </button>
            </div>
          </div>
        </ng-container>
      </div>

      <div *ngIf="!showemailSection" class="" [formGroup]="requestForm">
        <ng-container *ngIf="showRequestedUser && requestedMembers.length > 1">
          <div class="author_container">
            <div class="author-label-toggle">
              <div class="author-toggle-text">
                <h6 class="font-weight-bold mb-0">Change Requestor</h6>
                <p class="author-toggle-subtext">
                  Send this request on behalf of someone else
                </p>
              </div>
              <label class="switch">
                <input
                  type="checkbox"
                  [(ngModel)]="showAuthorDropdown"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="onAuthorToggleChange($event)"
                />
                <span
                  class="slider"
                  [style.background-color]="
                    showAuthorDropdown && secondary_button_color
                      ? secondary_button_color
                      : ''
                  "
                ></span>
              </label>
            </div>
            <div class="job__select" *ngIf="showAuthorDropdown">
              <ng-select
                class="job-select"
                [placeholder]="''"
                [items]="requestedMembers"
                [multiple]="false"
                [closeOnSelect]="true"
                [selectableGroup]="true"
                maxSelectedItems="1"
                bindValue="id"
                bindLabel="title"
                formControlName="externalUserSelcted"
              >
                <ng-template
                  ng-option-tmp
                  let-item="item"
                  let-item$="item$"
                  let-index="index"
                >
                  <div class="mobile-check custom-control custom-checkbox">
                    <input
                      id="item-{{ index }}"
                      class="custom-control-input"
                      type="checkbox"
                      [ngModelOptions]="{ standalone: true }"
                      [ngModel]="item$.selected"
                    />
                    <label class="custom-control-label">{{ item.title }}</label>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </ng-container>

        <div class="row froala-wysiwyg">
          <div class="col-12 request_edit">
            <gs-area-wysiwyg
              label="Content"
              name="Message"
              placeholder="Add a popup greeting, instructions, or a story tip..."
              rows="7"
              cssClass="spacing-lg"
              is
              name="Content"
              formControlName="message"
              [formControl]="requestForm.controls.message"
              type="text"
              [autoFocus]="true"
            ></gs-area-wysiwyg>
          </div>
        </div>
      </div>
      </div>

      <div class="generate__box">
        <ng-container>
          <div class="mr-3">
            <button
              type="button"
              *ngIf="showemailSection"
              [style.background]="primary_color ? secondary_button_color : ''"
              [disabled]="
                (requestForm.value.externalcampaign == -1 &&
                  requestForm.value.externalquestion == -1) ||
                isGreetingVideoPending ||
                !requestForm.controls.note_email.value ||
                disableSubmit
              "
              (click)="backGuestStories()"
              class="invite_guest btn min-width rs-footer-btn rs-footer-btn--secondary"
            >
              {{ "Back" }} &nbsp;
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="!showemailSection">
          <div class="">
            <button
              type="button"
              [style.background]="primary_color ? secondary_button_color : ''"
              [disabled]="
                (requestForm.value.externalcampaign == -1 &&
                  requestForm.value.externalquestion == -1) ||
                isGreetingVideoPending ||
                !requestForm.controls.note_email.value ||
                disableSubmit
              "
              (click)="
                isSingleInternalRequested
                  ? copyExternalUrl()
                  : GenearateExternalMainlLink()
              "
              class="invite_guest btn min-width rs-footer-btn rs-footer-btn--primary"
            >
              {{
                isSingleInternalRequested ? buttonText : "Create Link"
              }}
              &nbsp; <span><i class="fas fa-link"></i></span>
            </button>
          </div>
        </ng-container>

        <ng-container *ngIf="!showemailSection">
          <div>
            <button
              type="button"
              (click)="shareadthis()"
              [style.background]="primary_color ? secondary_button_color : ''"
              [disabled]="!isSingleInternalRequested || disableSubmit"
              class="invite_guest btn min-width rs-footer-btn rs-footer-btn--secondary"
            >
              Share &nbsp; <span><i class="fa-regular fa-share"></i></span>
            </button>
          </div>
        </ng-container>

        <ng-container>
          <div>
            <button
              type="button"
              [style.background]="primary_color ? secondary_button_color : ''"
              [disabled]="
                (!isSingleInternalRequested && !showemailSection) ||
                (showemailSection && !lastUserValid) ||
                disableSubmit
              "
              (click)="sendExternalMainEmail()"
              class="invite_guest btn min-width rs-footer-btn rs-footer-btn--secondary"
            >
              {{ !showemailSection ? "Email" : "Send" }}&nbsp;
              <span> <i class="fa-regular fa-envelope"></i></span>
            </button>
          </div>
        </ng-container>

        <ng-container>
          <div class="lang-icon-select" *ngIf="!showemailSection">
            <button
              type="button"
              class="rs-footer-btn rs-footer-btn--secondary"
              (click)="toggleLangDropdown($event)"
            >
              <i class="far fa-language"></i>
              <span>Translate</span>
            </button>

            <!-- CUSTOM DROPDOWN -->
            <ul class="icon-dropdown" *ngIf="langDropdownOpen">
              <li
                *ngFor="let lang of selectedLanguages"
                (click)="selectLanguage(lang, $event)"
                [class.active]="
                  lang.code === requestForm.get('languageSelected')?.value
                "
              >
                <img [src]="lang.flag" width="20" height="14" />
                {{ lang.name }}
              </li>
            </ul>
          </div>
        </ng-container>
      </div>
      <a
        *ngIf="externalUrlforCopy && isSingleInternalRequested"
        class="link_preview"
        [href]="externalUrlforCopy"
        target="_blank"
      >
        Click to Preview
      </a>

      <div
        class="remark-box__adthis"
        [@showhideadthis]="isDispalyadthis ? 'show' : 'hide'"
      >
        <div class="close__popup_Design">
          <button class="btn btn-trans ml-3" (click)="closeshare()">
            <svg role="img" class="">
              <use xlink:href="#icon-collapse"></use>
            </svg>
          </button>
        </div>
        <div
          #shareholic
          class="shareaholic-canvas"
          data-app="share_buttons"
          data-app-id="33117316"
        ></div>
      </div>
    </div>
    </div>
  </div>
  <div class="preview_body" *ngIf="isShowModal">
    <div class="preview-body">
      <ng-container *ngIf="isShowmedia">
        <app-storyflow-card-gallery-request
          [storyflowMenu]="menu"
          [menuActive]="stepActive"
          [interviewStyle]="false"
          [companyID]="companyId"
          [campaignId]="requestGalleryCampaignId"
          [questionModels]="questionModels"
          [showPreviousNextButton]="false"
          [currentCompany]="company"
          [inbound_builder]="false"
          [videoduration]="30"
          [reduceHeight]="false"
        ></app-storyflow-card-gallery-request>
      </ng-container>

      <ng-container *ngIf="isshowTag">
        <app-storyflow-card-tags-request
          [reduceHeight]="false"
          aria-label="Tags"
          tabindex="2"
          [inboundBuilder]="false"
          [companyId]="companyId"
          [stepId]="2"
          [inbound]="false"
          (closetagBox)="closetagbox($event)"
        >
        </app-storyflow-card-tags-request>
      </ng-container>
    </div>

    <div class="menu">
      <storyflow-menu-request
        [showHomeButton]="'true'"
        [isMediaIncluded]="true"
        [mediaIndex]="0"
        [storyflowMenu]="menu"
        [menuActive]="stepActive"
        (openTagView)="openTag($event)"
      >
      </storyflow-menu-request>
    </div>

    <!-- Bottom Tab-Style Minimize Button -->
    <div
      class="story-builder-bottom-tab"
      role="button"
      tabindex="0"
      aria-label="Close tags and media"
      [class.is-white-close]="isPanelCloseWhite"
      [style.background]="panelCloseColor"
      [style.border-color]="panelCloseColor"
      (click)="closeStoryBuilder()"
      (keydown.enter)="closeStoryBuilder()"
    >
      <svg role="img">
        <use xlink:href="#icon-collapse"></use>
      </svg>
    </div>
  </div>
</div>

<ng-container *ngIf="isBrowser">
  <mux-uploader
    id="my-uploader-gs"
    class="mux-uploader-hidden"
    no-progress
    no-status
    no-drop
    no-retry
    dynamic-chunk-size
    hidden
  >
    <button
      class="btn"
      type="button"
      slot="file-select"
      aria-label="Select a file"
    >
      Pick a file
    </button>
  </mux-uploader>
</ng-container>
